<template>
  <div v-if="navigation" class="add-new-item-admin">
    <title-bar
      submitBtn
      :submitBtnTitle="$t('messages.navigationCreate')"
      :title="$t('messages.navigationCreate')"
      @submitPressed="submitPressed"
    />
    <navigation-form
      :navigation-obj="navigation"
      :action="action"
      @clearAction="action = null"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar.vue";
import NavigationForm from "./components/NavigationForm.vue";

export default {
  components: {
    TitleBar,
    NavigationForm,
  },
  data() {
    return {
      action: null,
      navigation: {
          position: '',
          menu: []
      },
    };
  },
  methods: {
    submitPressed() {
      this.action = "add";
    },
  },
};
</script>
